<div [formGroup]="durationForm" class="flex flex-row gap-2">
  <mat-form-field>
    <mat-label>Years</mat-label>
    <input matInput type="number" formControlName="years" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Months</mat-label>
    <input matInput type="number" formControlName="months" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Days</mat-label>
    <input matInput type="number" formControlName="days" />
  </mat-form-field>
</div>
